import React, { PropsWithChildren } from 'react';
import { CSeverity, NativeProps } from '@/src/components/interfaces';
import { CAlert } from '@/src/components/c-alert/CAlert';

export interface CToastProps extends NativeProps {
  severity: CSeverity;
  onClose: () => (Promise<void> | void);
}

export function CToast(props: PropsWithChildren<CToastProps>): React.JSX.Element {
  return (
    <CAlert showIcon={true} severity={props.severity} onClose={props.onClose}>
      {props.children}
    </CAlert>
  );
}